interface AgrLinkage {
  isLinkedToAggregator?: boolean;
  parentPropertyTicker?: string;
}

export function isAgrEmailTemplate(entity: AgrLinkage): boolean {
  return !!entity?.isLinkedToAggregator || !!entity?.parentPropertyTicker;
}
